import React from 'react';
import LandingPage from '../Landing';
import logo from './hactivate-logo.svg';

class LandingPage1 extends React.Component {

  render() {
    const headerPosStyle = {
      position: 'relative',
      top: '50%'
    };

    const h2Style = { 
      display: "inline-block",
      color: "#E1E1E1",
      backgroundColor: "#252525",
      fontSize: "35px",
      margin: "0.2em 0.5em 0",
    };

    return (
      <LandingPage className="landingPage1" bgImg={this.props.bgImg} >

        <img className="hactivateLogo" src={logo} alt="hactivate" />

        <div style={headerPosStyle}>
          <p style={h2Style}>GAMING.</p>
          <p style={h2Style}>THE SYSTEM.</p><br/>
        </div>

      </LandingPage>
    );
  }
}

export default LandingPage1;



// WEBPACK FOOTER //
// ./src/components/LandingPage1/index.js